import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

/**
 * useSubformApi Hook
 *
 * Pure API hook for subform operations.
 *
 * @returns {Object} - { getSubform }
 */
const useSubformApi = () => {
  const getSubform = useCallback(async (subformId) => {
    const response = await axiosInstance.get(`/api/subforms/${subformId}`);
    return response.data;
  }, []);

  return { getSubform };
};

export default useSubformApi;
